import React, { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import { LoanSummaryCard } from "../../../components";

import { Link } from "react-router-dom";
import { Field } from "formik";
import { calculateTotalNoOfInstallments } from "../../../utils";
import AmortizationSchedule from "./AmortizationSchedule/AmortizationSchedule";
import PaymentDetails from "./PaymentDetails/PaymentDetails";
import Documents from "./Documents/Documents";
import SourceWiseSplitUp from "./SourceWiseSplitUp/SourceWiseSplitUp";
import RepaymentSchedule from "./RepaymentSchedule/RepaymentSchedule";
import { useDeepEffect } from "../../../abstracts";
import {
  getAmortizationSchedule,
  getRepaymentSchedule,
} from "../../../services";
import LoanDisclaimer from "./LoanDisclaimer";

const LoanSummaryDetails = ({
  keyValue,
  paymentMethod,
  tabChange,
  fieldValues,
  loanData,
  planData,
  loanStatus,
  loanSettingInfo,
  filteredValues,
  loanDataFromState,
  FieldInputCheck,
  checkBox,
  setSliderOpen1,
  setSliderOpen2,
  errors,
  today,
  sourceSplit,
  sourceSplitData,
  calculateTotalFees,
  calculateNetAmount,
  setModifyFor,
  principalPaid,
  isModified,
  showClose,
  setShowClose,
  requestId,
  setResponseLoading,
  amortizationSchedule,
  repaymentSchedule,
}) => {
  return (
    <div className="loan-summary-container">
      <LoanDisclaimer
        loanData={loanData}
        loanStatus={loanStatus}
        isModified={isModified}
        setModifyFor={setModifyFor}
        showClose={showClose}
        setShowClose={setShowClose}
        setSliderOpen2={setSliderOpen2}
      />
      <LoanSummaryCard
        loanData={loanData}
        planData={planData}
        loanSettingInfo={loanSettingInfo}
        employeeInfo={filteredValues}
        principalPaid={principalPaid}
        calculateTotalNoOfInstallments={calculateTotalNoOfInstallments}
      />
      {loanDataFromState != undefined && (
        <>
          <p className="ml-3 ft-14">
            <Field
              style={{
                height: "16px",
                width: "16px",
                marginRight: "10px",
                paddingBottom: "5px",
              }}
              name={"checkbox"}
              type="checkbox"
              id="opt1"
              component={FieldInputCheck}
              validate={() =>
                !document.querySelector("#opt1:checked")
                  ? "Please accept Terms and Conditions in order to proceed"
                  : undefined
              }
              onClick={checkBox()}
            />
            <span className="m-0">
              By checking this box, I declare that I have read the
            </span>
            <Link
              onClick={() => setSliderOpen1(true)}
              style={{ color: "#307BF6", marginLeft: "3px" }}
            >
              Terms and conditions
            </Link>
          </p>
          <p className="text-danger">{errors?.checkbox}</p>
        </>
      )}
      {["Active", "Closed", "Suspended"].includes(loanStatus) ? (
        <Tabs
          activeKey={keyValue}
          transition={false}
          onSelect={tabChange}
          mountOnEnter
          unmountOnExit
        >
          <Tab eventKey={1} title={"Repayment Schedule"}>
            <RepaymentSchedule
              repaymentData={repaymentSchedule}
              loanData={loanData}
            />
          </Tab>
          <Tab eventKey={2} title={"Amortization Schedule"}>
            <AmortizationSchedule
              amortizationSchedule={amortizationSchedule}
              loanStatus={loanStatus}
              loanData={loanData}
              requestId={requestId}
            />
          </Tab>
          <Tab eventKey={3} title={"Payment Details"}>
            <PaymentDetails
              paymentMethod={paymentMethod}
              fieldValues={fieldValues}
              loanData={loanData}
              loanSettingInfo={loanSettingInfo}
              today={today}
              calculateNetAmount={calculateNetAmount}
              calculateTotalFees={calculateTotalFees}
            />
          </Tab>
          <Tab eventKey={4} title={"Source-Wise Splitup"}>
            <SourceWiseSplitUp
              loanData={loanData}
              sourceSplit={sourceSplit}
              sourceSplitData={sourceSplitData}
              calculateNetAmount={calculateNetAmount}
            />
          </Tab>
          <Tab eventKey={5} title={"Documents"}>
            <Documents loanData={loanData} />
          </Tab>
        </Tabs>
      ) : (
        <Tabs
          activeKey={keyValue}
          transition={false}
          onSelect={tabChange}
          mountOnEnter
          unmountOnExit
        >
          <Tab eventKey={1} title={"Amortization Schedule"}>
            <AmortizationSchedule
              amortizationSchedule={amortizationSchedule}
              loanStatus={loanStatus}
              loanData={loanData}
              requestId={requestId}
            />
          </Tab>
          <Tab eventKey={2} title={"Payment Details"}>
            <PaymentDetails
              paymentMethod={paymentMethod}
              fieldValues={fieldValues}
              loanData={loanData}
              loanSettingInfo={loanSettingInfo}
              today={today}
              calculateNetAmount={calculateNetAmount}
              calculateTotalFees={calculateTotalFees}
            />
          </Tab>
          <Tab eventKey={3} title={"Source-Wise Splitup"}>
            <SourceWiseSplitUp
              loanData={loanData}
              sourceSplit={sourceSplit}
              sourceSplitData={sourceSplitData}
              calculateNetAmount={calculateNetAmount}
            />
          </Tab>
          <Tab eventKey={4} title={"Documents"}>
            <Documents loanData={loanData} />
          </Tab>
        </Tabs>
      )}
    </div>
  );
};

export default LoanSummaryDetails;
